import { render, staticRenderFns } from "./OrderErrorLogsList.vue?vue&type=template&id=5c115748&"
import script from "./OrderErrorLogsList.vue?vue&type=script&lang=js&"
export * from "./OrderErrorLogsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderErrorLogsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports